const appendFromHomeQueryParam = (path: string) => {
  if (path.includes('?')) {
    const [pathname, queryString] = path.split('?');
    const query = Object.fromEntries(
      new URLSearchParams(queryString).entries()
    );

    return {
      pathname,
      query: { ...query, from: 'home' },
    };
  }

  return {
    pathname: path,
    query: { from: 'home' },
  };
};

export default appendFromHomeQueryParam;
